import React, { FunctionComponent, useMemo } from 'react';

import { setHtml } from 'Modules/ui';
import { Typography, TypographyProps } from 'Modules/ui3';

import { WithContentSize } from '../types';


/*
    BLOCK: link
    PARAMS: title: string,
            url: string,
    EXAMPLE:
    {
        "type" : "link",
        "data" : {
            "title": "Source",
            "url": "https://editorjs.io/",
        }
    }
 */

interface LinkRendererProps extends WithContentSize {
    title?: string;
    url: string;
}

export const LinkRenderer: FunctionComponent<LinkRendererProps> = ({
    title,
    url,
    size,
}) => {
    const typographyProps = useMemo<TypographyProps<'a'>>(() => ({
        fontSize: {
            desktop: '20px',
            mobile: '16px',
        }[size],
        lineHeight: {
            desktop: '1.5',
            mobile: '1.4',
        }[size],
    }), [size]);
    return (
        <Typography
            component='a'
            target='_blank'
            rel='noopener nofollow norefferer'
            href={url}
            color='general.primary50'
            fontWeight='400'
            sx={{
                textDecoration: 'underline',
                '&:visited': {
                    color: 'general.primary50',
                },
                '&:hover': {
                    textDecoration: 'none',
                },
            }}
            {...typographyProps}
            {...setHtml(title && title !== '' ? title : url)}
        />
    );
};
